// Components
import AppCta from '../app-cta'
import AppScrollObject from '../app-scroll-object'

export default
{
    name: 'app-page-footer',

    components:
    {
        AppCta,
        AppScrollObject
    },

    props:
    {
        text:
        {
            type: String,
            default: ''
        },
        page:
        {
            type: Object,
            default: () =>
            {}
        },
        linkLabel:
        {
            type: String,
            default: ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-footer/script.js